/**
 * Simplified Search Menu Prevention
 *
 * This script primarily relies on CSS to hide menu content from browser search,
 * with minimal JavaScript intervention only when absolutely necessary.
 */

// Simple keyboard detection for search mode
let isSearchMode = false;
let searchTimeout = null;

function activateSearchMode() {
  isSearchMode = true;
  document.body.classList.add('search-mode-active');

  // Clear existing timeout
  if (searchTimeout) {
    clearTimeout(searchTimeout);
  }

  // Reset search mode after a delay
  searchTimeout = setTimeout(() => {
    isSearchMode = false;
    document.body.classList.remove('search-mode-active');
  }, 2000);
}

// Detect search keyboard shortcuts
document.addEventListener('keydown', (event) => {
  // CMD+F or Ctrl+F
  if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === 'f') {
    activateSearchMode();
  }

  // F3 (Find Next)
  if (event.key === 'F3') {
    activateSearchMode();
  }

  // Escape might close search
  if (event.key === 'Escape') {
    setTimeout(() => {
      isSearchMode = false;
      document.body.classList.remove('search-mode-active');
    }, 100);
  }
});

// Minimal intervention: Only close menus that open during search mode
document.addEventListener('DOMContentLoaded', () => {
  // Find menu details elements
  const menuDetails = document.querySelectorAll('header-menu details');

  menuDetails.forEach(details => {
    details.addEventListener('toggle', (event) => {
      // If a menu opens during search mode, close it immediately
      if (isSearchMode && details.hasAttribute('open')) {
        setTimeout(() => {
          details.removeAttribute('open');
          const summary = details.querySelector('summary');
          if (summary) {
            summary.setAttribute('aria-expanded', 'false');
          }
        }, 1);
      }
    });
  });
});
